export default __webpack_public_path__ + "static/media/malvaceae.024323d1.jpg";